import { request } from "/src/utils/index.js";

export function Search(params) {
  return request.get("sdm/marketing/customer/source", { params });
}

// 可扩展其他操作（如新增/删除），目前仅需查询
export function Add(params) {
  return request.post("sdm/customer/source/add", params);
}

export function Delete(data) {
  return request.delete("sdm/customer/source/delete", { data });
}
